module.exports = __webpack_public_path__ + "static/01-9b8f3a15296c7d022ff28b9631e05528.jpg";